/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { Skill } from './skill-model';
import { Activity } from './activity-model';

export class Experience {
	activities?: Array<Activity>

	skills?: Array<Skill>

	constructor(obj?: any) {
		if (obj) {
			Object.assign(
				this,
				obj
			);
		}
	}
}